<template>
    <div class="home">
        <!-- HERO -->
        <section class="hero">
            <div class="hero-grid"></div>
            
            <v-container class="hero-content" fluid>
                <div class="hero-text">
                    <img src="@/assets/logo.jpg" class="logo" alt="FlashX Logo" />
                                        
                    <h1 class="headline">
                        Неприступная<br /><span class="gradient-text">конфиденциальность</span>
                    </h1>

                    <p class="sub">
                        Шифрование мирового уровня. Нулевое логирование.
                        <br />Испытайте настоящую цифровую свободу.
                    </p>

                    <div class="actions">
                        <v-btn large class="btn-primary" elevation="0" href="https://t.me/flashxvpn1_bot" target="_blank">
                            <span class="btn-icon">→</span> Начать 
                        </v-btn>
                    </div>

                    <div class="stats">
                        <div class="stat">
                            <span class="stat-number">10Гбит+</span>
                            <span class="stat-label">Скорость серверов</span>
                        </div>
                        <div class="stat">
                            <span class="stat-number">24/7</span>
                            <span class="stat-label">Поддержка</span>
                        </div>
                        <div class="stat">
                            <span class="stat-number">99.9%</span>
                            <span class="stat-label">Время работы</span>
                        </div>
                    </div>
                </div>

                <div class="hero-visual">
                    <div class="floating-box box-1"></div>
                    <div class="floating-box box-2"></div>
                    <div class="floating-box box-3"></div>
                    <div class="floating-circle circle-1"></div>
                    <div class="floating-circle circle-2"></div>
                </div>
            </v-container>
        </section>

        <!-- FEATURES -->
        <section class="features">
            <v-container fluid>
                <div class="section-header">
                    <h2 class="section-title">Почему выбирают FLASHX</h2>
                    <p class="section-subtitle">Создано для скорости, безопасности и простоты</p>
                </div>

                <div class="features-grid">
                    <div class="feature-card" v-for="item in features" :key="item.title">
                        <div class="feature-icon">
                            <span>{{ item.icon }}</span>
                        </div>
                        <h3 class="feature-title">{{ item.title }}</h3>
                        <p class="feature-text">{{ item.text }}</p>
                        <div class="feature-accent"></div>
                    </div>
                </div>
            </v-container>
        </section>
    </div>
</template>

<script>
    export default {
        data: () => ({
            features: [
                { 
                    icon: '🔐', 
                    title: 'Современный протокол', 
                    text: 'Протокол с множеством функций для обхода и шифрованием. Ваши данные только ваши.'
                },
                { 
                    icon: '⚡', 
                    title: 'Молниеносная скорость', 
                    text: 'Оптимизированная глобальная сеть с средней задержкой 10 мс. Смотрите без буферизации.'
                },
                { 
                    icon: '🛡️', 
                    title: 'Защита от DDoS', 
                    text: 'Защита корпоративного уровня от любых атак. Всегда оставайтесь в безопасности.'
                },
                { 
                    icon: '💰', 
                    title: 'Демократичные цены', 
                    text: 'Доступные тарифы без скрытых комиссий. Платите только за то, что используете. '
                },
                { 
                    icon: '🚫', 
                    title: 'Нулевое логирование', 
                    text: 'Мы не ведем логи вашей активности. Полная конфиденциальность и анонимность гарантированы.'
                },
                { 
                    icon: '🌐', 
                    title: 'Кроссплатформенность', 
                    text: 'Работает на iOS, Android, Windows, macOS и Linux. Одна подписка для всех ваших устройств.'
                },
            ]
        })
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
    }

    .home {
        background: #ffffff;
        color: #000000;
        overflow: hidden;
    }

    /* ============ HERO SECTION ============ */
    .hero {
        position: relative;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        background: linear-gradient(135deg, #ffffff 0%, #f8f8f8 50%, #f0f0f0 100%);
        width: 100%;
    }

    .hero-grid {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: 
            linear-gradient(rgba(0, 0, 0, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 0, 0, 0.03) 1px, transparent 1px);
        background-size: 50px 50px;
        opacity: 0.5;
    }

    .hero .v-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        gap: 40px;
        position: relative;
        z-index: 1;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
    }

    .hero-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        gap: 40px;
        position: relative;
        z-index: 1;
        width: 100%;
        padding: 0 40px;
        max-width: 1200px;
        margin: 0 auto;
    }

    .hero-text {
        animation: slideInLeft 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .hero-visual {
        position: relative;
        height: 500px;
        animation: slideInRight 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    @keyframes slideInLeft {
        from {
            opacity: 0;
            transform: translateX(-50px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @keyframes slideInRight {
        from {
            opacity: 0;
            transform: translateX(50px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    .logo {
        width: 80px;
        height: 80px;
        margin-bottom: 30px;
        border-radius: 12px;
        object-fit: cover;
        animation: slideInLeft 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .badge {
        display: inline-block;
        padding: 8px 16px;
        background: rgba(0, 0, 0, 0.08);
        color: #1a1a1a;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 30px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-bottom: 20px;
    }

    .headline {
        font-size: 72px;
        font-weight: 800;
        line-height: 1.1;
        letter-spacing: -2px;
        margin-bottom: 24px;
        color: #000000;
    }

    .gradient-text {
        background: linear-gradient(135deg, #000000 0%, #333333 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .sub {
        font-size: 18px;
        line-height: 1.6;
        color: #555555;
        margin-bottom: 40px;
        max-width: 500px;
    }

    .actions {
        display: flex;
        gap: 16px;
        margin-bottom: 60px;
        align-items: center;
    }

    .btn-primary {
        background: #000000 !important;
        color: white !important;
        border-radius: 50px;
        padding: 16px 36px !important;
        font-weight: 600;
        font-size: 16px;
        transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        cursor: pointer;
    }

    .btn-primary:hover {
        transform: translateY(-4px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
        background: #333333 !important;
    }

    .btn-icon {
        margin-right: 8px;
        display: inline-block;
        transition: transform 0.3s;
    }

    .btn-primary:hover .btn-icon {
        transform: translateX(4px);
    }

    .btn-secondary {
        color: #000000 !important;
        font-weight: 600;
        transition: all 0.3s;
        border: 2px solid #000000 !important;
    }

    .btn-secondary:hover {
        background: #f0f0f0 !important;
    }

    .stats {
        display: flex;
        gap: 60px;
        padding-top: 40px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    .stat {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .stat-number {
        font-size: 28px;
        font-weight: 800;
        color: #000000;
    }

    .stat-label {
        font-size: 13px;
        color: #888888;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    /* HERO VISUAL ELEMENTS */
    .floating-box,
    .floating-circle {
        position: absolute;
        border-radius: 20px;
    }

    .floating-box {
        width: 120px;
        height: 120px;
        border: 2px solid rgba(0, 0, 0, 0.15);
        backdrop-filter: blur(10px);
        background: rgba(255, 255, 255, 0.6);
    }

    .box-1 {
        top: 10%;
        right: 10%;
        animation: float 6s ease-in-out infinite;
    }

    .box-2 {
        bottom: 20%;
        right: 5%;
        animation: float 7s ease-in-out infinite;
        animation-delay: 1s;
    }

    .box-3 {
        top: 50%;
        right: 25%;
        animation: float 8s ease-in-out infinite;
        animation-delay: 2s;
    }

    .floating-circle {
        border: 2px solid rgba(0, 0, 0, 0.15);
    }

    .circle-1 {
        width: 80px;
        height: 80px;
        top: 30%;
        right: 15%;
        animation: pulse 3s ease-in-out infinite;
    }

    .circle-2 {
        width: 60px;
        height: 60px;
        bottom: 40%;
        right: 10%;
        animation: pulse 4s ease-in-out infinite;
        animation-delay: 0.5s;
    }

    @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-30px); }
    }

    @keyframes pulse {
        0%, 100% { 
            transform: scale(1);
            opacity: 0.5;
        }
        50% { 
            transform: scale(1.1);
            opacity: 0.8;
        }
    }

    /* ============ FEATURES SECTION ============ */
    .features {
        padding: 100px 40px;
        background: #ffffff;
    }

    .section-header {
        text-align: center;
        margin-bottom: 80px;
    }

    .section-title {
        font-size: 42px;
        font-weight: 800;
        color: #000000;
        margin-bottom: 16px;
        letter-spacing: -1px;
    }

    .section-subtitle {
        font-size: 16px;
        color: #666666;
        max-width: 500px;
        margin: 0 auto;
    }

    .features-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 32px;
        width: 100%;
    }

    .feature-card {
        position: relative;
        padding: 28px;
        background: #f5f5f5;
        border-radius: 24px;
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        overflow: hidden;
        border: 1px solid rgba(0, 0, 0, 0.08);
        max-width: 100%;
    }

    .feature-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, rgba(0, 0, 0, 0.03) 0%, transparent 100%);
        opacity: 0;
        transition: opacity 0.4s;
    }

    .feature-card:hover {
        transform: translateY(-12px);
        background: #eeeeee;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
        border-color: rgba(0, 0, 0, 0.15);
    }

    .feature-card:hover::before {
        opacity: 1;
    }

    .feature-icon {
        width: 48px;
        height: 48px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        margin-bottom: 16px;
        transition: all 0.4s;
        background: #e8e8e8;
    }

    .feature-card:hover .feature-icon {
        transform: scale(1.1) rotate(-5deg);
        background: #dddddd;
    }

    .feature-title {
        font-size: 18px;
        font-weight: 700;
        color: #000000;
        margin-bottom: 10px;
    }

    .feature-text {
        font-size: 14px;
        color: #666666;
        line-height: 1.5;
        margin-bottom: 16px;
    }

    .feature-accent {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 4px;
        width: 0;
        background: #000000;
        transition: width 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .feature-card:hover .feature-accent {
        width: 100%;
    }

    /* ============ CTA SECTION ============ */
    .cta {
        padding: 100px 0;
        background: #000000;
        position: relative;
        overflow: hidden;
    }

    .cta::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -10%;
        width: 500px;
        height: 500px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 50%;
        filter: blur(80px);
    }

    .cta::after {
        content: '';
        position: absolute;
        bottom: -30%;
        left: -5%;
        width: 400px;
        height: 400px;
        background: rgba(255, 255, 255, 0.03);
        border-radius: 50%;
        filter: blur(70px);
    }

    .cta-content {
        text-align: center;
        position: relative;
        z-index: 1;
    }

    .cta-content h2 {
        font-size: 48px;
        font-weight: 800;
        color: white;
        margin-bottom: 16px;
        letter-spacing: -1px;
    }

    .cta-content p {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 40px;
    }

    .btn-large {
        padding: 18px 48px !important;
        font-size: 16px !important;
        background: white !important;
        color: #000000 !important;
    }

    .btn-large:hover {
        background: #f0f0f0 !important;
        box-shadow: 0 20px 50px rgba(255, 255, 255, 0.2);
    }

    /* ============ RESPONSIVE ============ */
    @media (max-width: 1025px) {
        .hero .v-container,
        .hero-content {
            grid-template-columns: 1fr;
            gap: 40px;
            padding: 0 24px;
        }

        .features-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
        }

        .headline {
            font-size: 52px;
            line-height: 1.15;
        }

        .hero-visual {
            display: none;
        }

        .stats {
            gap: 40px;
        }

        .section-title {
            font-size: 36px;
        }

        .feature-card {
            padding: 28px;
        }

        .features {
            padding: 80px 24px;
        }
    }

    @media (max-width: 768px) {
        .features-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
        }

        .headline {
            font-size: 44px;
        }

        .sub {
            font-size: 16px;
        }

        .section-title {
            font-size: 32px;
        }

        .section-subtitle {
            font-size: 15px;
        }

        .feature-card {
            padding: 24px;
        }

        .feature-title {
            font-size: 16px;
        }

        .feature-text {
            font-size: 13px;
        }

        .logo {
            width: 64px;
            height: 64px;
            margin-bottom: 24px;
        }

        .cta-content h2 {
            font-size: 40px;
        }

        .cta-content p {
            font-size: 16px;
        }

        .features {
            padding: 60px 20px;
        }

        .section-header {
            margin-bottom: 50px;
        }
    }

    @media (max-width: 600px) {
        .features-grid {
            grid-template-columns: 1fr;
            gap: 16px;
        }

        .headline {
            font-size: 36px;
            line-height: 1.2;
        }

        .sub {
            font-size: 14px;
            line-height: 1.5;
            margin-bottom: 32px;
        }

        .actions {
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 40px;
        }

        .btn-primary {
            width: 100%;
        }

        .stats {
            flex-direction: column;
            gap: 24px;
            padding-top: 24px;
        }

        .stat-number {
            font-size: 24px;
        }

        .stat-label {
            font-size: 12px;
        }

        .section-title {
            font-size: 26px;
        }

        .section-subtitle {
            font-size: 14px;
        }

        .feature-card {
            padding: 20px;
        }

        .feature-icon {
            width: 40px;
            height: 40px;
            font-size: 24px;
            margin-bottom: 12px;
        }

        .feature-title {
            font-size: 15px;
        }

        .feature-text {
            font-size: 12px;
            line-height: 1.4;
            margin-bottom: 12px;
        }

        .logo {
            width: 56px;
            height: 56px;
            margin-bottom: 20px;
        }

        .cta {
            padding: 60px 0;
        }

        .cta-content h2 {
            font-size: 28px;
            margin-bottom: 12px;
        }

        .cta-content p {
            font-size: 14px;
            margin-bottom: 32px;
        }

        .btn-large {
            padding: 14px 32px !important;
            font-size: 14px !important;
            width: 100%;
        }

        .features {
            padding: 60px 16px;
        }

        .section-header {
            margin-bottom: 40px;
        }

        .hero .v-container,
        .hero-content {
            padding: 0 16px;
        }
    }

    @media (max-width: 480px) {
        .headline {
            font-size: 28px;
        }

        .sub {
            font-size: 13px;
        }

        .section-title {
            font-size: 22px;
        }

        .cta-content h2 {
            font-size: 24px;
        }

        .stat-number {
            font-size: 20px;
        }
    }
</style>

